import styled, { css } from "styled-components";

import designSystemColors from "../../styles";

export const InputWithErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #00000085;
  font-weight: 300;
  letter-spacing: 0%;
  margin-bottom: 8px;
`;

export const RequiredSpan = styled.span`
  color: ${designSystemColors.errorColor};
`;

export const StyledTextArea = styled.textarea<{
  hasError?: boolean;
  height?: number;
}>`
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid
    ${({ hasError }) =>
      hasError
        ? css`
            ${designSystemColors.errorColor} !important
          `
        : designSystemColors.border.input};
  resize: none;
  height: ${({ height }) => height || "80px"};
  &:disabled {
    background: #ccc !important;
    opacity: 0.4;
    cursor: no-drop;

    &::placeholder {
      color: ${designSystemColors.textDark};
    }
  }
`;

export const BottomWrapper = styled.div<{ shouldJustifyEnd?: boolean }>`
  margin-top: 8px;
  display: flex;
  gap: 8px;
  justify-content: ${({ shouldJustifyEnd }) =>
    shouldJustifyEnd ? "flex-end" : "space-between"};
`;

export const Counter = styled.span`
  display: block;
  font-size: 12px;
  color: #00000085;
`;

export const ErrorMessage = styled.span`
  display: block;
  font-size: 12px;
  color: ${designSystemColors.errorColor};
`;
